import { render, staticRenderFns } from "./WeightGuide.vue?vue&type=template&id=1949d85e"
import script from "./WeightGuide.vue?vue&type=script&lang=js"
export * from "./WeightGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports